'use client'

import { motion } from 'motion/react'
import * as React from 'react'
import { PaginationButton, PaginationDirection } from '@components/pagination-button'
import { trackButtonClicked, TrackedButtonNames } from '@utils/analytics'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'

type SoloImageDisplayProps = {
  image: string
  numImages: number
  onChangeImage?: (direction: PaginationDirection) => void
  className?: string
}
export const generatedSampleId = 'generated'
export const SoloImageDisplay = ({
  image,
  numImages,
  onChangeImage
}: SoloImageDisplayProps): React.ReactElement | null => {
  const [currImage, setCurrImage] = React.useState<string>(image)

  React.useEffect(() => {
    setCurrImage(image)
  }, [image])

  return (
    <div
      className="gap-y-md relative flex h-full w-full flex-grow flex-col items-center justify-center"
      key={'solo-image-display'}
    >
      <div className="gap-md relative h-full w-full flex-col items-center justify-between self-stretch md:flex-row-reverse">
        <motion.div
          className="relative h-full w-full items-center justify-center"
          key={image}
          layout
          initial={{ opacity: 0, scale: 1 }}
          exit={{ opacity: 0 }}
          animate={{
            opacity: 1
          }}
          transition={{
            type: 'tween',
            duration: 0.3
          }}
        >
          <ImageWithCustomLoader src={currImage} alt="Generated Image" style={{ objectFit: 'contain' }} fill />
        </motion.div>
        {numImages > 1 ? (
          <>
            <div className="absolute left-[-16px] top-0 z-[60] flex h-full flex-col justify-center" key="left">
              <motion.div transition={{ type: 'spring', duration: 1 }}>
                <PaginationButton
                  direction={PaginationDirection.Left}
                  onClick={(event) => {
                    event.stopPropagation()
                    onChangeImage?.(PaginationDirection.Left)
                    trackButtonClicked(TrackedButtonNames.paginateLeft, {
                      customProperties: {
                        'Pagination Direction': 'Left',
                        Image: currImage
                      }
                    })
                  }}
                />
              </motion.div>
            </div>
            <div className="absolute right-[-16px] top-0 z-[60] flex h-full flex-col justify-center" key="right">
              <motion.div animate={{}} transition={{ type: 'spring', duration: 1 }}>
                <PaginationButton
                  direction={PaginationDirection.Right}
                  onClick={(event) => {
                    event.stopPropagation()
                    onChangeImage?.(PaginationDirection.Right)
                    trackButtonClicked(TrackedButtonNames.paginateRight, {
                      customProperties: {
                        'Pagination Direction': 'Right',
                        Image: currImage
                      }
                    })
                  }}
                />
              </motion.div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  )
}
